import theme from '../../../themes/pTheme/pTheme'

export const chartCallback = (chart) => {
  if (!chart.options.plugins?.drawBars) return
  const ctx = chart.ctx
  const xAxis = chart.scales.x
  const yAxis = chart.scales.y
  const spacing = chart.options.plugins.drawBars.spacing || 10
  const barCount = (xAxis.ticks.length - 1) / 3 // Calculate the number of bars
  const barWidth = (xAxis.width - spacing * barCount) / barCount // Calculate the width of each bar

  ctx.save()

  // Draw vertical bars
  for (let i = 0; i < barCount; i++) {
    if (yAxis?.chart?.legend?.chart?.legend?.legendItems[1]?.text === '') {
      ctx.fillStyle = theme.palette.hpWhite // Set color for each bar
    } else {
      ctx.fillStyle = i % 2 === 0 ? theme.palette.hpBaseLighter : theme.palette.hpWhite // Set color for each bar
    }
    const x = xAxis.left + (barWidth + spacing) * i // Calculate x coordinate for the current bar
    ctx.fillRect(x, yAxis.top, barWidth + spacing, yAxis.bottom - yAxis.top) // Draw the bar
  }

  ctx.restore()
}
export const customBarsPlugin = {
  id: 'customBars',
  beforeDraw: chartCallback
}
